var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCustomer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b4b4b4",
    floodOpacity: 0.471
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-554 -4722)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 554, 4722)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)",
    fill: "#025b5f",
    stroke: "#e4e4e6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(568.5 4733.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 8,
    transform: "translate(0.5 0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5 10.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.938,12.5a6.25,6.25,0,1,0-6.25-6.25A6.25,6.25,0,0,0,10.938,12.5Zm4.375,1.562H14.5a8.5,8.5,0,0,1-7.119,0H6.562A6.564,6.564,0,0,0,0,20.625v2.031A2.344,2.344,0,0,0,2.344,25H19.531a2.344,2.344,0,0,0,2.344-2.344V20.625A6.564,6.564,0,0,0,15.313,14.062Z",
    transform: "translate(5 3.5)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCustomer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Customer.c39bc60c.svg";
export { ForwardRef as ReactComponent };